// convives.ts - NOMBRE DE CONVIVES MAX par réservation (6 septembre 2026,
// docs/rules/parametres-resto.md § « Contrat app mobile - convives max »).
//
// Un plafond choisi par le restaurateur (Paramètres → Services), lu par
// l'app mobile pour BORNER son sélecteur de convives, vérifié par les Cloud
// Functions à la création d'une demande future (ceinture), et repris par la
// page Paramètres pour borner les tailles de tables (fixes et « max par
// réservation » des tables flexibles) : une table plus grande que ce qu'un
// client peut demander n'a pas de sens.
//
// SEUL point d'accès au réglage : `maxConvives(p)` - jamais
// `parametres.max_convives` en direct (défaut, bornes et arrondi vivent ici).
import type { RestoParametres } from './types';
import { MAX_CONVIVES_DEFAUT, MAX_CONVIVES_MAX, MAX_CONVIVES_MIN } from './constants';

/**
 * Plafond de convives par réservation pour ce resto : la valeur enregistrée,
 * bornée à [MIN, MAX] et arrondie ; défaut MAX_CONVIVES_DEFAUT quand le
 * champ est absent ou invalide (resto jamais configuré, ancien document).
 */
export function maxConvives(p: RestoParametres | null | undefined): number {
  const v = p?.max_convives;
  if (typeof v !== 'number' || !Number.isFinite(v) || v < MAX_CONVIVES_MIN) {
    return MAX_CONVIVES_DEFAUT;
  }
  return Math.min(MAX_CONVIVES_MAX, Math.floor(v));
}

/** Valeurs proposées au restaurateur (Paramètres → Services) : 2 … MAX. */
export const MAX_CONVIVES_CHOIX: readonly number[] = Array.from(
  { length: MAX_CONVIVES_MAX - 1 },
  (_, i) => i + 2,
);

/**
 * Tailles proposées pour une TABLE FIXE (planning du lendemain, template
 * calendrier, zones) : de 2 au plafond de convives - au-delà, aucune
 * réservation ne pourrait la remplir. La valeur courante est conservée si
 * elle dépasse (plafond abaissé après coup) : le restaurateur voit sa table
 * telle qu'elle est, et peut la réduire.
 */
export function choixCapaciteTable(maxConv: number, courant?: number): number[] {
  const plafond = Math.max(2, Math.min(MAX_CONVIVES_MAX, maxConv));
  const out = Array.from({ length: plafond - 1 }, (_, i) => i + 2);
  if (courant !== undefined && courant > 0 && !out.includes(courant)) out.push(courant);
  return out.sort((a, b) => a - b);
}
